var _path, _circle, _circle2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 96,
    viewBox: "0 0 164 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.137 86.5C106.137 91.7467 101.884 96 96.637 96L66.637 96C61.3903 96 57.137 91.7467 57.137 86.5C57.137 81.2533 61.3903 77 66.637 77L66.8766 77C63.8928 75.325 61.8767 72.1306 61.8767 68.4653C61.8767 63.0635 66.2557 58.6845 71.6575 58.6845L37.137 58.6845C31.7352 58.6845 27.3561 54.3054 27.3561 48.9036C27.3561 43.5018 31.7351 39.1228 37.137 39.1228L75.1008 39.1228C69.703 39.1181 65.3287 34.7409 65.3287 29.342C65.3287 23.9402 69.7078 19.5612 75.1096 19.5612L26.7808 19.5612C21.379 19.5612 17 15.1822 17 9.78035C17 4.37856 21.379 -0.000468259 26.7808 -0.000468731L105.027 -0.000475572C110.429 -0.000476044 114.808 4.37855 114.808 9.78035C114.808 15.1821 110.429 19.5612 105.027 19.5612L132.644 19.5612C138.046 19.5612 142.425 23.9402 142.425 29.342C142.425 34.7438 138.046 39.1228 132.644 39.1228L118.844 39.1228C124.242 39.1275 128.616 43.5047 128.616 48.9036C128.616 54.3054 124.237 58.6845 118.836 58.6845L153.356 58.6844C158.758 58.6844 163.137 63.0635 163.137 68.4653C163.137 73.8671 158.758 78.2461 153.356 78.2461L101.344 78.2461C104.207 79.8825 106.137 82.9659 106.137 86.5Z",
    fill: "#EDFFF5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 5.99951,
    r: 2,
    fill: "#27AE60"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9999,
    cy: 72.9995,
    r: 2,
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.703 47.8532L151.5 47.5723L151.297 47.8532L149.132 50.8532L148.846 51.2495H149.335H153.665H154.154L153.868 50.8532L151.703 47.8532Z",
    stroke: "#27AE60",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71645 12.8745L3.49994 12.4995L3.28343 12.8745L1.11837 16.6245L0.901863 16.9995H1.33488H5.665H6.09802L5.88151 16.6245L3.71645 12.8745Z",
    stroke: "#27AE60",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/no-data-icon.533955abe39ee8527b31be6e38c8c861.svg";
export { ForwardRef as ReactComponent };